import script from "./SessionView.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionView.vue?vue&type=script&setup=true&lang=js"

import "./SessionView.vue?vue&type=style&index=0&id=6a4a353a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a4a353a"]])

export default __exports__